export default {
    iframeSrc: '/iframes/immoscout',
};
